var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.dataObj.componentName,{tag:"component",attrs:{"data-obj":_vm.dataObj}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }